interface EAVaultFreshnessBarProps {
  totalDocs: number
  staleDocs: number
  freshDocs: number
  variant?: 'full' | 'compact'
}

export default function EAVaultFreshnessBar({
  totalDocs,
  staleDocs,
  freshDocs,
  variant = 'full',
}: EAVaultFreshnessBarProps) {
  const stalePercent = totalDocs > 0 ? (staleDocs / totalDocs) * 100 : 0
  const freshPercent = totalDocs > 0 ? (freshDocs / totalDocs) * 100 : 0

  if (variant === 'compact') {
    let dotColor = '#10b981' // green - all fresh
    if (stalePercent > 80) {
      dotColor = '#ef4444' // red
    } else if (stalePercent > 50) {
      dotColor = '#f59e0b' // yellow
    }

    return (
      <span
        className="inline-block w-2.5 h-2.5 rounded-full"
        style={{ background: dotColor, boxShadow: `0 0 6px ${dotColor}66` }}
        title={`${freshDocs}/${totalDocs} fresh`}
        aria-label={`${freshDocs} of ${totalDocs} documents fresh`}
      />
    )
  }

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium" style={{ color: 'rgba(148, 163, 184, 0.8)' }}>
          Document Freshness
        </span>
        <span className="text-xs font-semibold" style={{ color: '#e2e8f0' }}>
          {freshDocs}/{totalDocs} fresh
        </span>
      </div>
      <div
        className="w-full h-2.5 rounded-full overflow-hidden flex"
        style={{ background: 'rgba(30, 41, 59, 0.6)' }}
        role="progressbar"
        aria-valuenow={freshDocs}
        aria-valuemin={0}
        aria-valuemax={totalDocs}
        aria-label={`${freshDocs} of ${totalDocs} documents are fresh`}
      >
        {freshPercent > 0 && (
          <div
            className="h-full rounded-l-full transition-all duration-500"
            style={{
              width: `${freshPercent}%`,
              background: 'linear-gradient(90deg, #10b981, #34d399)',
            }}
          />
        )}
        {stalePercent > 0 && (
          <div
            className="h-full rounded-r-full transition-all duration-500"
            style={{
              width: `${stalePercent}%`,
              background: 'linear-gradient(90deg, #ef4444, #f87171)',
            }}
          />
        )}
      </div>
      <div className="flex items-center justify-between mt-1.5">
        <div className="flex items-center space-x-3">
          <span className="flex items-center space-x-1">
            <span className="w-2 h-2 rounded-full" style={{ background: '#10b981' }} />
            <span className="text-xs" style={{ color: 'rgba(148, 163, 184, 0.6)' }}>
              Fresh ({freshDocs})
            </span>
          </span>
          <span className="flex items-center space-x-1">
            <span className="w-2 h-2 rounded-full" style={{ background: '#ef4444' }} />
            <span className="text-xs" style={{ color: 'rgba(148, 163, 184, 0.6)' }}>
              Stale ({staleDocs})
            </span>
          </span>
        </div>
      </div>
    </div>
  )
}
